module.exports = __webpack_public_path__ + "static/img/new2.f5d34eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/new2.jpg
// module id = 7gNZ
// module chunks = 1